<template>

  <div>

    <template v-if="loading">
      <v-progress-circular indeterminate />
    </template>

    <template v-else>

      <!-- compact version (for smaller viewports) -->
      <div class="d-lg-none">

        <v-menu :close-on-content-click="false">

          <template v-slot:activator="{ props }">
            <v-btn v-bind="props" :text="$t('titles.products_selected', {selected: model.length, total: products.length})" />
          </template>

          <v-list v-model:selected="model" select-strategy="independent">
            <v-list-item
              v-for="product in products"
              :key="product.id"
              :title="product.name"

              :value="product.id"
            >
              <template v-slot:prepend="{ isSelected, select }">
                <v-list-item-action start>
                  <v-checkbox-btn
                    :model-value="isSelected"
                    @update:model-value="select"
                    :color="VerticalRegistry.get(product.vertical)?.color"
                  />
                </v-list-item-action>
              </template>
            </v-list-item>
          </v-list>

        </v-menu>

      </div>

      <!-- full version (for larger viewports) -->
      <div class="d-none d-lg-block">
        <v-checkbox
          v-for="product in products"
          :key="product.id"
          :label="product.name"
          :color="VerticalRegistry.get(product.vertical)?.color"
          hide-details
          density="compact"
          v-model="model"
          :value="product.id"
          multiple
        />
      </div>

    </template>

  </div>

</template>

<script setup lang="ts">

/**
 * Meant to be used in the sidebar slot of the CalendarWithSidebar component.
 */

import VerticalRegistry from '../verticals/VerticalRegistry'

export interface ProductOption {
  id: number | string
  name: string
  vertical: string
}

interface Props {
  products?: ProductOption[]
  loading?: boolean
}

withDefaults(defineProps<Props>(), {
  products: () => [],
  loading: false,
})

const model = defineModel<(number | string)[]>({required: true})

</script>
